import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-task",
  "use": "icon-task-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-task\">\r\n  <path id=\"icon-task_task\" d=\"M44,4V44H4V4Zm4-4H0V48H48ZM40,14H24v2H40Zm0,10H24v2H40Zm0,10H24v2H40ZM18.968,11.392,17.548,10l-5.106,5.214-3.078-2.9-1.4,1.42,4.5,4.27Zm0,10L17.548,20l-5.1,5.214-3.078-2.9-1.4,1.418L12.468,28Zm0,10L17.548,30l-5.1,5.214-3.078-2.9-1.4,1.418L12.468,38Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol